var _ellipse, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 151,
    viewBox: "0 0 156 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 77.6332,
    cy: 75.5,
    rx: 77.476,
    ry: 75.5,
    fill: "#58A291"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2676 74.3555H42.1387C40.9576 74.3555 40 75.313 40 76.4941V105.01C40 106.191 40.9576 107.148 42.1387 107.148H49.2676C50.4487 107.148 51.4063 106.191 51.4063 105.01V76.4941C51.4063 75.313 50.4487 74.3555 49.2676 74.3555Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4835 62.3855L74.4859 74.0331C74.1862 75.7803 76.02 77.1125 77.589 76.2877L88.0491 70.7885L98.5092 76.2877C100.078 77.1125 101.912 75.7803 101.612 74.0331L99.6146 62.3855L108.077 54.1368C109.346 52.8995 108.646 50.7437 106.892 50.4889L95.1971 48.7895L89.9669 38.1921C89.1824 36.6026 86.9157 36.6026 86.1312 38.1921L80.9012 48.7894L69.2065 50.4887C67.4524 50.7437 66.7519 52.8993 68.0213 54.1366L76.4835 62.3855Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M112.222 88.5905C110.774 86.1771 107.728 85.2603 105.188 86.4736L92.2296 92.6647C91.013 97.1236 86.9648 100.269 82.2649 100.269C81.6655 100.269 81.0604 100.216 80.4664 100.111L65.9937 97.5592C64.8595 97.3592 64.0372 96.3157 64.1837 95.1733C64.3399 93.9537 65.4803 93.125 66.6767 93.3362L81.2088 95.8986C84.5043 96.4796 87.647 94.2792 88.2282 90.9837C88.8093 87.6881 86.6088 84.5454 83.3132 83.9643L75.2432 82.5413C74.1563 82.3497 73.1548 81.851 72.347 81.099C67.811 76.8774 61.3211 75.695 55.6836 77.8141V104.082L70.6312 108.648C73.5687 109.545 76.6155 110 79.6868 110C85.6755 110 91.4986 108.28 96.5267 105.027L110.506 95.9813C112.977 94.3829 113.735 91.1137 112.222 88.5905Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStep3);
export default __webpack_public_path__ + "static/media/icon-step3.602f2d2154091dbbc720167abab130c8.svg";
export { ForwardRef as ReactComponent };